import ViewLayout_vue_vue_type_script_setup_true_lang_default from "./ViewLayout.vue.script.js";
//#region src/components/ViewLayout/ViewLayout.vue
var ViewLayout_default = ViewLayout_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ViewLayout_default as default };

//# sourceMappingURL=ViewLayout.vue.js.map